function updateNostopallotColumnHeights() {
    // Select all .nosto-column elements inside .nostopallot
    const nostoColumns = document.querySelectorAll('.nostopallot .nosto-column');


    if (nostoColumns.length > 0) {
        // Loop through each .nosto-column element
        nostoColumns.forEach(function(column) {
            // Get the computed width of the column
            const width = window.getComputedStyle(column).width;

            // Set the height of the column to match its width
            column.style.height = width;
        });
    }
}
document.addEventListener('DOMContentLoaded', function() {
    // Initial update
    updateNostopallotColumnHeights();

    // Update heights on window resize
    window.addEventListener('resize', updateNostopallotColumnHeights);

    new ScrollReveal().reveal('.nostopallot .nosto-column', {
        delay: 0,
        duration: 1000,
        distance: '150px',
        reset: false
    });
});
